import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { CommonServices } from "../../common.services";
import { CancelTripComponent } from "../cancel-trip/cancel-trip.component";
import { CustomerServiceService } from "../customer-service.service";
import { TripsDetailsComponent } from "../trips-details/trips-details.component";
import { WindowRefService } from "../../window-ref.service";
import * as _ from "lodash";
import {
  MapInfoWindow,
  MapMarker,
  MapDirectionsService,
  MapGeocoder,
} from "@angular/google-maps";

import { map, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { CustomerCancelQuoteComponent } from "../customer-cancel-quote/customer-cancel-quote.component";
import { SharedService } from "src/app/shared-modules/shared.service";
declare var $: any;

@Component({
  selector: "app-trips",
  templateUrl: "./trips.component.html",
  styleUrls: ["./trips.component.css"],
})
export class TripsComponent implements OnInit, OnDestroy {
  countdownInterval: any;
  // markerOptions: google.maps.MarkerOptions = {
  //   draggable: false,
  //   icon: "./assets/img/truck_icon1.png",
  //   opacity: 0.2,
  // };
  // markerPositions: google.maps.LatLngLiteral[] = [];
  // info!: MapInfoWindow;
  zoom = 7;
  center: google.maps.LatLngLiteral = { lat: 21.14, lng: 79.08 };
  // center: google.maps.LatLngLiteral = { lat: 20.5937, lng: 78.9629 };
  arrayMarker: any = [];
  curLoc: any = {};
  startLoc: any = {};
  endLoc: any = {};
  trackTimerObj: any;
  cancelTrip: boolean = false;
  cancelTripIndex: number = 0;
  payTripIndex: number = 0;
  viewTripIndex: number = 0;
  payNowTripIndex: number = 0;
  matdialogRef: MatDialogRef<CustomerCancelQuoteComponent> | undefined;
  matDialogref: MatDialogRef<TripsDetailsComponent> | undefined;
  tripType: any = "-1";
  otherTrips: boolean = false;
  token: any;
  selTripDetails: any;
  trips: any;
  paid_amount: any;
  total_amount: any;
  amount_paid: any;
  balance_amount: any;
  transporterTrips: boolean = false;
  taxDetails: any;
  refundAmount: number = 0;
  cancelReasonForm!: FormGroup;
  document_array: any = [];
  fetch_page: any = 0;
  currentPage: any = 0;
  total_cat_count: any;
  searchButton: boolean = true;
  search_Btn: boolean = false;
  toggleSearch: boolean = false;
  cancelSearchButton: boolean = false;
  isInputValid: boolean = false;
  previousValue: string = "";
  private lengthState: number = 0;
  @ViewChild("newItem", { static: false }) inputElement!: ElementRef;
  startPage: any = 1;
  last_page: any = 1;
  profileDetails: any;
  internetHandlingChanrges: any;
  tax: any;
  paynowAmt: any;
  totalAmount: any;
  tax_details: any = [];
  loading: boolean = false;
  tripsArray: any = [];
  live_track: boolean = false;
  trips_track: boolean = true;
  trackArray: any = [];
  latlngArray: any = [];
  directionsResults$: Observable<google.maps.DirectionsResult | undefined>;
  isRouteAdded = false;
  otp: boolean = true;
  customerCode: any;
  currentArry: any = [];
  cancelButton: boolean = true;
  tripNumber: any = -1;
  paymentResponse: any;
  tripsloading: boolean = false;
  tripsDownload: any;
  quotation: any;
  loadCategory: any;
  sharedData: any;
  infoContent = "";
  map: any;
  totalReceivable: number = 0;
  isLoading: boolean = false;
  isFullTrackingLoading: boolean = false;
  showFullTracking: boolean = false;
  fullTrackData: any = null;
  data: any;

  constructor(
    private router: Router,
    private matDialog: MatDialog,
    private services: CustomerServiceService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private commonService: CommonServices,
    private windowRef: WindowRefService,
    private mapDirectionsService: MapDirectionsService,
    private geocoder: MapGeocoder,
    private shrdSrvcs: SharedService
  ) { }

  ngOnInit(): void {
    this.token = sessionStorage.getItem("token");
    const quotation = sessionStorage.getItem("quotes");
    if (quotation === "quotes") {
      this.tripType = "quotes";
      this.fetch_page = 1;
      this.startPage = 1;
      this.getTripsDetails(this.tripType, this.tripNumber);
      this.document_array = [];
    }
    this.cancelReasonForm = this.formBuilder.group({
      transportDetails: [""],
      otherDetails: [""],
    });
    // this.getTripsDetails(this.tripType, this.tripNumber);
    this.pagination(1);
    if (this.token == null) {
      this.router.navigateByUrl("/");
    }
    this.commonService
      .getPublishedEvent("tripAssigned")
      .subscribe((result) => {
      });

    this.getProfile();

    let number = 8.5424499578;
    let round_number = Math.round(number);

    this.countdownInterval = setInterval(() => {
      this.updateCountdowns();
    }, 1000);
  }

  async ngAfterViewInit() { }
  getProfile() {
    this.services.GetProfile(this.token).subscribe(
      (profileRes: any) => {
        this.profileDetails = profileRes.body.data;
      },
      (error) => {
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  GoToDashboard() {
    this.router.navigate(["/dashboard"]);
    sessionStorage.removeItem("quoteBooked");
  }
  GoToTrips() {
    location.reload();
    this.router.navigate(["/trips"]);
  }

  updateCountdowns() {
    if (!this.trips) return;
    const currentTime = Date.now();
    this.trips.forEach((trip: any) => {
      if (trip.trip_status === 'quote' && trip.quote_expiry_time) {
        const expiryTime = new Date(trip.quote_expiry_time).getTime();
        const remainingTime = expiryTime - currentTime;
        
        if (remainingTime > 0) {
          const hours = Math.floor(remainingTime / (1000 * 60 * 60));
          const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
          
          let countdownStr = '';
          if (hours > 0) countdownStr += `${hours}h `;
          if (minutes > 0 || hours > 0) countdownStr += `${minutes}m `;
          countdownStr += `${seconds}s`;
          
          trip.countdownTimer = countdownStr.trim();
        } else {
          trip.countdownTimer = 'Expired';
        }
      }
    });
  }

  acceptQuote(tripId: any) {
    this.services.acceptQuote(this.token, tripId).subscribe(
      (response: any) => {
        if (response.status === 200 || response.status === 201) {
          this.snackBar.open("Quote accepted successfully!", "Success", { duration: 5000 });
          this.getTripsDetails(this.tripType, this.tripNumber);
        }
      },
      (error) => {
        this.snackBar.open(error.error?.message || "Failed to accept quote", "Fail", { duration: 5000 });
      }
    );
  }
  GoToCancelTrip(index: number, status: string) {
    this.cancelTripIndex = index;

    if (status == "cancelled") {
      this.snackBar.open("This Trip is already Cancelled", "Fail", {
        duration: 5000,
      });
      return;
    }
    this.cancelTrip = true;
    this.GetTaxDetails();
  }

  payNow(i: number, tripsItem: any, item: any) {
    this.loading = true;
    this.payNowTripIndex = i;
    let balance = tripsItem.price_details?.amount_paid;
    let data = {
      trip_id: item._id,
      amount: balance,
    };
    this.services.GeneratePaymentOrder(data, this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          const paymentData = {
            price_details: {
              actual_price: tripsItem.price_details?.amount_paid,
              total_amount: this.totalAmount,
              amount_paid: this.paynowAmt,
              tax_details: this.tax_details,
            },
          };

          this.services
            .TripPayment(paymentData, response.body.data._id, this.token)
            .subscribe((res: any) => {
              this.onlinePayment(res, this.token, response);
              this.loading = false;
            });
        }
        this.loading = false;
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  onlinePayment(res: any, token: any, tripBookingResponse: any) {
    this.getProfile();
    var options = {
      key: environment.razorpay_key, // Enter the Key ID generated from the Dashboard
      amount: this.paynowAmt * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency: "INR",
      name: "S9trucks",
      description: `2nd payment is successful for trip id: ${tripBookingResponse?.trip_id}`,
      image:
        "https://s9trucks.s3.us-east-2.amazonaws.com/1660327946469%20-%20S9256.png",
      order_id: res.body.data.id,
      handler: (response: any) => {
        const payload = {
          success: {
            razorpay_payment_id: response.razorpay_payment_id,
            order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature,
          },
          paymentStatus: "fully-paid",
        };
        this.services

          .updatePaymentResponse(
            token,
            payload,
            tripBookingResponse?.payment_details[0]._id
          )
          .subscribe(
            (payResponse: any) => {
              if (payResponse) {
                this.paymentResponse = payResponse.body.data;
                window.location.reload();
              }
              this.commonService.publishMessage(
                "tripAssigned",
                tripBookingResponse.body.data
              );
              this.router.navigate(["/trips"]);
            },
            (error) => {
              if (error.error.message === "jwt malformed") {
                this.router.navigateByUrl("/");
              }
              this.snackBar.open(error.error.message, "Fail", {
                duration: 5000,
              });
            }
          );
      },
      prefill: {
        name: this.profileDetails.username,
        email: this.profileDetails.email ? this.profileDetails.email : "",
        contact: this.profileDetails.mobile,
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#f25510",
      },
    };
    var rzp1 = new this.windowRef.nativeWindow.Razorpay(options);
    rzp1.open();
    rzp1.on("payment.failed", (errorResponse: any) => {
      rzp1.close();
      this.snackBar.open(errorResponse.error.reason, "fail", {
        duration: 5000,
      });

      const payload = {
        failure: {
          code: errorResponse.error.code,
          description: errorResponse.error.description,
          reason: errorResponse.error.reason,
          order_id: errorResponse.error.metadata.order_id,
          razorpay_payment_id: errorResponse.error.metadata.payment_id,
        },
        paymentStatus: "failed",
      };
      location.reload();

      // this.services
      //   .updatePaymentResponse(token, payload, res.body.paymentInfo._id)
      //   .subscribe(
      //     (payResponse: any) => {
      //       this.router.navigate(["/trips"]);
      //     },
      //     (error) => {
      //       if (error.error.message === "jwt malformed") {
      //         this.router.navigateByUrl("/");
      //         window.localStorage.clear();
      //       }
      //       if (error.error.message === "jwt malformed") {
      //         this.router.navigateByUrl("/");
      //         window.localStorage.clear();
      //       }
      //       this.snackBar.open(error.error.message, "Fail", {
      //         duration: 5000,
      //       });
      //     }
      //   );
    });
  }

  payBalance(i: number, tripsItem: any, item: any) {
    this.loading = true;
    this.close();
    this.payNowTripIndex = i;
    let balance =
      tripsItem.price_details?.total_amount -
      tripsItem.price_details?.amount_paid;
    let data = {
      trip_id: item._id,
      remaining_amount: Number(balance),
    };
    this.services.GeneratePaymentOrder(data, this.token).subscribe(
      (response: any) => {
        if (response.status === 201) {
          this.onlinePayment(response, this.token, item);
        }
        this.loading = false;
        this.getTripsDetails(this.tripType, this.tripNumber);
      },
      (error) => {
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  cancelQuote(item: any) {
    this.viewTripIndex = item;
    this.matdialogRef = this.matDialog.open(CustomerCancelQuoteComponent, {
      data: item,
      autoFocus: false,
    });
    this.matdialogRef.afterClosed().subscribe((res) => {
      this.getTripsDetails(this.tripType, this.tripNumber);
    });
  }

  GoToTripDetails(item: any) {
    if (item.trip_status == "expired") {
      this.snackBar.open(
        "Trip has not been assigned yet please try after sometime",
        "Success",
        {
          duration: 5000,
        }
      );
    } else {
      this.viewTripIndex = item;
      this.matDialogref = this.matDialog.open(TripsDetailsComponent, {
        width: "100%",
        maxHeight: "80vh",
        data: item,
      });
    }
  }
  GoToTruckLoadDetails(item: any) {
    if (item.trip_status !== "quoteBooked") {
      this.snackBar.open(
        "Truck has not been available yet please try after sometime",
        "Success",
        {
          duration: 5000,
        }
      );
    } else {
      this.router.navigateByUrl("/truck-details");
      sessionStorage.setItem("quoteBooked", "quoteBooked");
      this.viewTripIndex = item;
      this.shrdSrvcs.sendData(this.viewTripIndex);
    }
  }

  getTripsList(selectedTripType: any) {
    this.tripType = selectedTripType;
    if (this.tripType == "-1") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getTripsDetails(this.tripType, this.tripNumber);
      this.document_array = [];
    } else if (this.tripType == "liveTrips") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getTripsDetails(this.tripType, this.tripNumber);
      this.document_array = [];
    } else if (this.tripType == "upcoming") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getTripsDetails(this.tripType, this.tripNumber);
      this.document_array = [];
    } else if (this.tripType == "completed") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getTripsDetails(this.tripType, this.tripNumber);
      this.document_array = [];
    } else if (this.tripType == "cancelled") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getTripsDetails(this.tripType, this.tripNumber);
      this.document_array = [];
    } else if (this.tripType == "expired") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getTripsDetails(this.tripType, this.tripNumber);
      this.document_array = [];
    } else if (this.tripType == "quotes") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getTripsDetails(this.tripType, this.tripNumber);
      this.document_array = [];
    } else if (this.tripType == "quoteCancel") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getTripsDetails(this.tripType, this.tripNumber);
      this.document_array = [];
    } else {
      this.getTripsDetails(this.tripType, this.tripNumber);
    }
  }
  others() {
    this.otherTrips = true;
    this.transporterTrips = false;
  }
  transporter() {
    this.transporterTrips = true;
    this.otherTrips = false;
  }
  cancel() {
    this.otherTrips = false;
    this.transporterTrips = false;
  }

  getTripsDetails(tripType: any, type: any) {
    this.tripsloading = true;
    this.tripNumber = type;
    this.services
      .GetTripList(this.token, this.startPage, tripType, this.tripNumber)
      .subscribe(
        (response: any) => {
          this.trips = response.body.data;
          //added by logan because of hardcoded `0` index payment status is used to diaplay paybalance button on html
          this.trips = _.forEach(this.trips, (item) => {
            item.payment_details = _.filter(item.payment_details, (payItem) => {
              return payItem.payment_status != "not-paid";
            });
          });
          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta.lastPage;

          this.tripsloading = false;
          for (let i = 0; i < this.trips.length; i++) {
            for (let j = 0; j < this.trips[i].payment_details.length; j++) {
              if (
                this.trips[i].payment_details[0].payment_status ===
                "fully-paid" ||
                this.trips[i].payment_details[0].payment_status ===
                "partial-paid"
              ) {
                if (
                  this.trips[i].trip_status === "tripstarted" ||
                  "trip-booked"
                ) {
                  this.trips[i].live_track = true;
                } else {
                  this.trips[i].live_track = false;
                }
              } else {
                this.trips[i].live_track = false;
              }

              this.total_amount =
                this.trips[i].payment_details[j].price_details.total_amount;
              this.paid_amount =
                this.trips[i].payment_details[j].price_details.amount_paid;
              this.balance_amount = this.total_amount - this.paid_amount;
            }
          }
        },

        (error) => {
          this.trips = [];
          this.tripsloading = false;
          if (error.status == 404) {
            this.last_page = 1;
            return;
          }
          if (error.status === 401) {
            this.router.navigateByUrl("/");
            localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            localStorage.clear();
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            localStorage.clear();
          }
          return;
        }
      );
  }

  tripCancel(item: any) {
    let reasonSelected = "";
    let reasonDisc = "";

    if (this.transporterTrips) {
      reasonSelected = "I have a better deal from other website or transporter";
      reasonDisc = this.cancelReasonForm.value.transportDetails;
    } else if (this.otherTrips) {
      reasonSelected = "others";

      reasonDisc = this.cancelReasonForm.value.otherDetails;
      if (reasonDisc == "") {
        this.snackBar.open("Enter the cancellation reason", "Fail", {
          duration: 2000,
        });
        return;
      }
    } else {
      reasonSelected = "My trip as been postponed or cancelled";
    }

    const tripData = {
      reason: reasonSelected,
      description: reasonDisc,
    };

    this.services.cancellationTrip(item, tripData, this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.cancelTrip = false;
          this.trips.splice(this.cancelTripIndex, 1);
          this.getTripsDetails(this.tripType, this.tripNumber);
          this.commonService.publishMessage("tripAssigned", response.body.data);
          this.snackBar.open("Trip Cancellation Success", "Success", {
            duration: 5000,
          });
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  GoToBookATrips() {
    sessionStorage.removeItem("quoteBooked");
    this.router.navigateByUrl("/");
  }

  close() {
    this.cancelTrip = false;
  }

  public GetTaxDetails() {
    var price =
      this.trips[this.cancelTripIndex].payment_details[0].price_details
        .actual_price;
    this.refundAmount = price;
    this.services.GetTaxdetails().subscribe(
      (response: any) => {
        if (response.status == 401) {
          this.router.navigateByUrl("/");
        }
        this.taxDetails = response.body.data;
        // this.taxDetails.forEach((ele: any) => {
        //   ele.tax_amount = price * (ele.tax_amount?.replace("%", "") / 100);
        //   this.refundAmount -= ele.tax_amount;
        // });
        const { totalTaxPercent, totalTaxRupees } = this.taxDetails.reduce(
          (acc: any, tax: any) => {
            const taxDeduction = parseFloat(tax.tax_deduction) || 0;
            if (tax.tax_type === "percent") {
              acc.totalTaxPercent +=
                (taxDeduction / 100) *
                this.trips[this.cancelTripIndex].payment_details[0]
                  .price_details.actual_price;
              //     .actual_price;
            } else if (tax.tax_type === "amount") {
              acc.totalTaxRupees += taxDeduction;
            }
            return acc;
          },
          { totalTaxPercent: 0, totalTaxRupees: 0 }
        );
        this.totalReceivable =
          this.trips[this.cancelTripIndex].payment_details[0].price_details
            .actual_price - totalTaxPercent;
      },
      (error) => {
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  pagination(page_status: any) {
    if (page_status == "-1") {
      this.fetch_page = parseInt(this.fetch_page) - 1;
      this.currentPage = this.fetch_page;
      this.startPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.fetch_page) + 1;
      this.fetch_page = this.currentPage;
      this.startPage = this.fetch_page;
    }
    if (page_status == "first") {
      this.fetch_page = this.document_array[0].currentPage;
      this.startPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.fetch_page = this.document_array[0].lastPage;
      this.startPage = this.document_array[0].lastPage;
    }
    this.getTripsDetails(this.tripType, this.tripNumber);
  }

  // liveTrack(item: any) {
  //   this.loading = true;
  //   this.clearAllIntervals();
  //   this.selTripDetails = this.trips.find((trip: any) => trip._id === item);
  //   /// calling the service to get the LatLng history for a given Trip
  //   this.services.customerTrack(this.token, item).subscribe((response: any) => {
  //     this.latlngArray = response.body.data;
  //     this.loading = false;

  //     // if (!this.latlngArray || this.latlngArray.length === 0) {
  //     //   this.snackBar.open("Truck location not detected.", "Info", {
  //     //     duration: 2000,
  //     //   });
  //     // }
  //   });

  //   this.trips_track = false;
  //   this.liveTracking(item, true);

  //   ///Calling the service in a interval mode to get the current lat lng postion
  //   this.trackTimerObj = setInterval(() => {
  //     this.liveTracking(item);
  //   }, 10000);
  // }

  liveTrack(item: any) {
    this.selTripDetails = this.trips.find((trip: any) => trip._id === item);
    this.isLoading = true;
    this.curLoc = [];
    this.trips_track = false;
    this.showFullTracking = false;
    this.isFullTrackingLoading = true;
    this.fullTrackData = null;
    this.trackArray = this.selTripDetails;
    this.data = null;

    // Clear any existing interval before starting a new one
    if (this.trackTimerObj) {
      clearInterval(this.trackTimerObj);
    }

    // Call latest location to get the fast response (one time only)
    this.services.latestLocation(this.token, item).subscribe(
      (res: any) => {
         if (!this.showFullTracking) {
             this.isLoading = false;
             this.processLocationData(res.body.data);
         }
      },
      (error) => {
         this.isLoading = false;
         this.handleTrackingError(error);
      }
    );

    // Initial fetch for full tracking in background
    this.services.tracking(this.token, item).subscribe(
      (response: any) => {
         this.isFullTrackingLoading = false;
         this.fullTrackData = response.body.data;
         if (this.showFullTracking) {
             this.processLocationData(this.fullTrackData, true);
         }
      },
      (error) => {
         this.isFullTrackingLoading = false;
         this.handleTrackingError(error);
      }
    );
  }

  viewFullTracking() {
    this.showFullTracking = true;
    if (this.fullTrackData) {
      this.processLocationData(this.fullTrackData);
    } else {
      this.isLoading = true;
    }

    if (this.trackTimerObj) {
      clearInterval(this.trackTimerObj);
    }

    const tripId = this.selTripDetails?._id;
    if (tripId) {
      const fetchFullTrackingData = () => {
        this.services.tracking(this.token, tripId).subscribe(
          (response: any) => {
             this.fullTrackData = response.body.data;
             if (this.showFullTracking) {
                 this.processLocationData(this.fullTrackData, true);
             }
          },
          (error) => {
             this.handleTrackingError(error);
          }
        );
      };

      fetchFullTrackingData();
      this.trackTimerObj = setInterval(fetchFullTrackingData, 10000);
    }
  }

  handleTrackingError(error: any) {
    this.isLoading = false;
    if (
      error?.error?.message === "jwt malformed" ||
      error?.error?.message === "jwt expired"
    ) {
      this.router.navigateByUrl("/");
      window.localStorage.clear();
    }
    if (error?.error?.message) {
      this.snackBar.open(error.error.message, "Fail", {
        duration: 5000,
      });
    }
  }

  processLocationData(dataObj: any, isFullTracking = false) {
    if (isFullTracking && this.trackArray) {
      this.trackArray.truckLocInfo = dataObj?.truckLocInfo || dataObj?.truckLocation;
      this.trackArray.truckLocation = dataObj?.truckLocation || dataObj?.truckLocInfo;
      this.trackArray.routeSegments = dataObj?.routeSegments || [];
    } else if (dataObj) {
      this.trackArray = dataObj;
    }
    
    const locArray = this.trackArray?.truckLocInfo || this.trackArray?.truckLocation;
    if (!locArray?.length) return;

    let locations = locArray.flat(Infinity);
    
    this.data = locations[locations.length - 1] || {};
    this.otp = this.trackArray.customerCode?.code != null;

    const existingKeys = new Set();
    this.curLoc = locations
      .map((loc: any) => ({
        ...loc,
        lat: Number(loc.latitude),
        lng: Number(loc.longitude),
      }))
      .filter((loc: any) => {
        if (!loc.lat || !loc.lng || isNaN(loc.lat) || isNaN(loc.lng) || loc.lat === 0 || loc.lng === 0) {
          return false;
        }
        const key = `${loc.lat},${loc.lng}`;
        if (existingKeys.has(key)) {
          return false;
        }
        existingKeys.add(key);
        return true;
      });

    this.startLoc = {
      lat: this.trackArray?.pickup_details?.from_lat,
      lng: this.trackArray?.pickup_details?.from_long,
    };
    this.endLoc = {
      lat: this.trackArray?.dropoff_details?.to_lat,
      lng: this.trackArray?.dropoff_details?.to_long,
    };

    if ((!this.data.address || String(this.data.address).toLowerCase() === 'unknown') && this.data.latitude && this.data.longitude) {
      this.geocoder
        .geocode({
          location: {
            lat: Number(this.data.latitude),
            lng: Number(this.data.longitude),
          },
        })
        .subscribe(({ results }) => {
          if (results && results.length) {
            this.data.address = results[0].formatted_address;
          }
        });
    }
  }

  vertices: google.maps.LatLngLiteral[] = this.latlngArray;

  closeTracking() {
    this.trips_track = true;
    this.curLoc = { lat: 0, lng: 0 };
    this.trackArray = null;
    this.data = null;
    this.clearAllIntervals();
  }
  consignNote(item: any) {
    window.open(item.consignment_details.consignment_url as any, "_blank");
  }

  closeModel() {
    $("#myModal").modal("hide");
  }

  onInputChange(input: HTMLInputElement) {
    const value = input.value;
    this.previousValue = value;

    const containsSpecialChars = /[^\w\d]/.test(value);
    if (containsSpecialChars) {
      input.value = value.replace(/[^\w\d]/g, "");
      this.previousValue = input.value;
      this.snackBar.open("Special characters are not allowed", "Fail", {
        duration: 5000,
      });
      return;
    }

    if (this.cancelSearchButton) {
      this.search_Btn = true;
      this.cancelSearchButton = false;
    }

    this.isInputValid = value.trim().length >= 3;

    if (value.length === 0) {
      if (this.tripNumber !== -1) {
        this.callApi();
      }
    }
  }

  private callApi() {
    this.tripNumber = -1;
    this.fetch_page = 0;
    this.startPage = 1;
    this.getTripsDetails(this.tripType, this.tripNumber);
  }

  cancelSearch() {
    this.toggleSearch = false;
    this.cancelSearchButton = false;
    this.searchButton = true;
    this.isInputValid = false;
    this.previousValue = "";
    this.tripNumber = -1;
    this.fetch_page = 0;
    this.startPage = 1;
    this.getTripsDetails(this.tripType, this.tripNumber);
  }

  openSearch() {
    this.searchButton = false;
    this.cancelSearchButton = false;
    this.toggleSearch = true;
    this.search_Btn = true;
    this.isInputValid = false;
    this.previousValue = "";
    if (this.toggleSearch) {
      setTimeout(() => this.inputElement?.nativeElement?.focus(), 0);
    }
  }

  search(value: any) {
    if (!value) {
      this.tripNumber = -1;
      this.fetch_page = 0;
      this.startPage = 1;
      this.getTripsDetails(this.tripType, this.tripNumber);
      this.searchButton = true;
      this.toggleSearch = false;
      this.cancelSearchButton = false;
    } else {
      this.cancelSearchButton = true;
      this.search_Btn = false;
      this.searchButton = false;
      this.fetch_page = 0;
      this.startPage = 1;
      this.getTripsDetails(this.tripType, value);
    }
  }

  help() {
    this.router.navigateByUrl("/?target=support");
  }

  clearAllIntervals() {
    const interval_id = window.setInterval(function () { },
      Number.MAX_SAFE_INTEGER);
    for (let i = 1; i < interval_id; i++) {
      window.clearInterval(i);
    }
  }

  ngOnDestroy(): void {
    this.clearAllIntervals();
  }
  marker(item: any, i: any) {
    this.data = item?.truckLocation[item.truckLocation.length - 1] || {};
    this.arrayMarker = item[i];
    $("#myModal").modal("show");
  }

  // openInfo(marker: MapMarker, content: string) {
  //   this.infoContent = content;
  //   this.info.open(marker);
  // }
  openModal(item: any) {
    $("#myModal").modal("show");
  }
}
